var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticStyle:{"height":"100%"},attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }